import create from 'zustand';
import { Device } from '../../../../../../../types/Device';

interface IsLayoutFormChangedState {
    isLayoutFormChanged: boolean;
    setIsLayoutFormChanged: (isDeviceAdded: boolean) => void;
    isNotSavedModalVisible: boolean;
    setIsNotSavedModalVisible: (isDeviceAdded: boolean) => void;
    layoutViewType: '2x2' | '1х5' | '3х4' | '3х3' | '2х8' | '1х12' | '4х4' | '1х7';
    setLayoutViewType: (
        size: '2x2' | '1х5' | '3х4' | '3х3' | '2х8' | '1х12' | '4х4' | '1х7',
    ) => void; // Добавили метод для изменения состояния
    pendingChanges: {
        devices: Device[];
        viewType?: string;
        name?: string;
        description?: string;
    } | null;
    setPendingChanges: (pendingChanges: { devices: Device[]; viewType?: string } | null) => void;
}

export const useIsLayoutFormChanged = create<IsLayoutFormChangedState>((set) => ({
    isLayoutFormChanged: false,
    isNotSavedModalVisible: false,
    layoutViewType: '2x2', // Установили начальное значение
    pendingChanges: null,
    setPendingChanges: (pendingChanges) =>
        set({
            pendingChanges: pendingChanges,
        }),
    setIsLayoutFormChanged: (isLayoutFormChanged: boolean) => set({ isLayoutFormChanged }),
    setIsNotSavedModalVisible: (isNotSavedModalVisible: boolean) => set({ isNotSavedModalVisible }),
    setLayoutViewType: (
        layoutViewType: '2x2' | '1х5' | '3х4' | '3х3' | '2х8' | '1х12' | '4х4' | '1х7',
    ) => set({ layoutViewType }), // Метод для изменения состояния
}));
